import { render, staticRenderFns } from "./DsarPerRequirementType.vue?vue&type=template&id=39b8091c&"
import script from "./DsarPerRequirementType.vue?vue&type=script&lang=js&"
export * from "./DsarPerRequirementType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports